import {
  OAuthProvider,
  getAuth,
  signInWithPopup,
  getAdditionalUserInfo,
} from "firebase/auth";
import Cookies from "js-cookie";
import { logActivity } from "./activityLog";

export const getUserImg = async (result) => {
  let profImg = null;

  const credential = OAuthProvider.credentialFromResult(result);
  if (credential?.accessToken) {
    try {
      const graphResp = await fetch(
        "https://graph.microsoft.com/v1.0/me/photo/$value",
        {
          headers: { Authorization: `Bearer ${credential.accessToken}` },
        },
      );

      if (graphResp.ok) {
        const blob = await graphResp.blob();

        profImg = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      }
    } catch (err) {
      console.warn("Microsoft profile image not available", err);
    }
  }
  return profImg;
};

const LoginAuthV2 = async (navigate, navPath, setStatus, setIsLoading) => {
  const auth = getAuth();
  const provider = new OAuthProvider("microsoft.com");

  provider.setCustomParameters({
    prompt: "select_account",
  });
  provider.addScope("User.Read");
  setIsLoading(true);

  await signInWithPopup(auth, provider)
    .then(async (result) => {
      // setIsLoading(false);
      const user = result.user;
      const idToken = await user.getIdToken();

      Cookies.set(
        "token",
        idToken,
        process.env.NODE_ENV === "production" && {
          secure: true,
          sameSite: "strict",
        },
      );
      Cookies.set(
        "userId",
        user.uid,
        process.env.NODE_ENV === "production" && {
          secure: true,
          sameSite: "strict",
        },
      );

      localStorage.setItem("userName", user.displayName);
      localStorage.setItem("userEmail", user.email);
      const profImg = await getUserImg(result);

      if (profImg) localStorage.setItem("profImg", profImg);
      else localStorage.removeItem("profImg");

      localStorage.setItem(
        "newUser",
        String(getAdditionalUserInfo(result)?.isNewUser ?? false),
      );

      logActivity({
        category: "auth",
        event: "login_success",
        uid: user.uid,
        email: user.email,
        message: "User logged in successfully",
      });

      navigate(navPath);
    })
    .catch((error) => {
      // setIsLoading(false);
      const errorCode = error.code;
      setStatus(errorCode);
    })
    .finally(() => {
      setIsLoading(false);
    });
};

export default LoginAuthV2;
